// import ReactMarkdown from 'react-markdown';
import { Disclosure } from '@headlessui/react';

import type { IFAQ } from '@boc/framework';
import { FAQSchema } from '@boc/framework';

import { JigsawIcon } from '~/local/components/icons';

const FAQ = ({ faqs }: { faqs: (IFAQ & { seo?: boolean })[] }) => {
  return (
    <div className="relative mt-12 w-full text-primary-2-80">
      <FAQSchema faqs={faqs.filter((f) => f.seo)} />
      <div className="flex flex-col divide-y divide-primary-2-20">
        {faqs.map((faq, index) => (
          <Disclosure
            as="div"
            key={`faq-${index}`}
            className="group/faq flex flex-col gap-4 py-6 sm:px-4"
          >
            <Disclosure.Button className="flex items-center justify-between gap-x-4 ">
              <h3 className="flex flex-1 text-left text-medium leading-6 text-neutral-2 group-hover/faq:text-primary-2-80 ui-open:text-primary-2-80">
                {faq.question}
              </h3>
              <div className="">
                <JigsawIcon className="text-primary-2-80 opacity-40 group-hover/faq:opacity-100 ui-open:-rotate-90 ui-open:transform ui-open:opacity-100" />
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="mt-6">
              <div className="text-base leading-5 text-primary-2-80">
                {/* <ReactMarkdown>{faq.answer}</ReactMarkdown> */}
                {faq.answer}
              </div>
            </Disclosure.Panel>
          </Disclosure>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
